import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { SectionHeader } from "components/molecules";
import Container from "components/core/Page/Container";
import illustrationImage from "assets/images/psp/illustration-search.svg";
import { PSP_LINKS_CONTENT_MAP } from "config/pspLinksData";
import PspLinkCard from "components/molecules/PspLinkCard";
import "./PspLinks.scss";

export default function PspLinks({
	background,
	storageGridContent: {
		title = "More Ways to Store",
		image = illustrationImage,
		storageTypes = []
	} = {}
}) {
	const mappedStorageTypes = storageTypes
		.map((storage) => {
			if (typeof storage === "string") {
				return PSP_LINKS_CONTENT_MAP[storage];
			}
			return storage;
		})
		.filter(Boolean); // Remove any undefined entries

	return (
		<section className={classnames("psp-links-section", background)}>
			<Container>
				<div className="psp-links-container">
					<SectionHeader
						title={title}
						image={image}
						contentAlign="text-center"
						titleProps={{
							size: "xxlarge",
							weight: "bold",
							color: "black",
							style: { padding: 0 }
						}}
						className="title"
						isPageContainer={false}
					/>
					<div className="psp-links-grid">
						{mappedStorageTypes.map((storage) => (
							<PspLinkCard
								key={storage.id}
								image={storage.image}
								title={storage.title}
								description={storage.description}
								link={storage.link}
							/>
						))}
					</div>
				</div>
			</Container>
		</section>
	);
}

PspLinks.propTypes = {
	background: PropTypes.oneOf(["light-blue", "white"]),
	storageGridContent: PropTypes.shape({
		title: PropTypes.string,
		image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
		storageTypes: PropTypes.arrayOf(
			PropTypes.oneOfType([
				PropTypes.string, // String identifiers that map to contentMap
				PropTypes.shape({
					id: PropTypes.string.isRequired,
					title: PropTypes.string.isRequired,
					description: PropTypes.string.isRequired,
					image: PropTypes.string.isRequired,
					link: PropTypes.string.isRequired
				})
			])
		)
	})
};

PspLinks.defaultProps = {
	background: "light-blue"
};
